import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import {
  changeListSelected,
  changeListSelectedCompany,
  handleCheckAllPort,
  selectIsAllCheck,
  selectListSelected,
  selectListSelectedCompanyExclude,
} from '../../../store/slicePortfolio'
import { GroupCriteria } from '../GroupCriteria'
import classes from '../index.module.scss'
import { InputSearchCompanyExclude } from './InputSearchCompanyExclude'
import { InputSearchPortfolio } from './InputSearchPortfolio'

export const Portfolio = () => {
  const dispatch = useDispatch()

  const listSelected = useSelector(selectListSelected)
  const listIdsSelectedCompany = useSelector(selectListSelectedCompanyExclude)
  const isAll = useSelector(selectIsAllCheck)

  //Actions
  const handelDeletePort = (value) => {
    dispatch(changeListSelected(value))

    if (listSelected.length === 1) {
      dispatch(handleCheckAllPort())
    }
  }

  const handelDeleteCompany = (value) => {
    dispatch(changeListSelectedCompany(value))
  }

  const renderWhenStatusAll = () => {
    return <Translate value="library.filterSetting.ALL_ITEMS_SELECT" />
  }

  return (
    <div className={classes.Portfolio}>
      <div className="dFlex" style={{ paddingRight: 110 }}>
        <Element
          style={{ borderColor: '#9C9C9C' }}
          className={classes.PortfolioSelect}
        >
          <InputSearchPortfolio />
          <Element elementName="p" className="fstItalic">
            {isAll ? (
              <Translate value="library.filterSetting.ALL_ITEMS_SELECT" />
            ) : (
              <Translate
                value={`library.main.${
                  !listSelected?.length || listSelected?.length < 2
                    ? 'ITEM_SINGLE_SELECT'
                    : 'ITEM_SELECT'
                }`}
                count={listSelected?.length}
              />
            )}
          </Element>
        </Element>
        <div className={classes.ExcludeSelect}>
          <InputSearchCompanyExclude />
          <Element elementName="p" className="fstItalic">
            {!!listIdsSelectedCompany.length && (
              <Translate
                value={`library.main.${
                  !listIdsSelectedCompany?.length ||
                  listIdsSelectedCompany?.length < 2
                    ? 'ITEM_SINGLE_SELECT'
                    : 'ITEM_SELECT'
                }`}
                count={listIdsSelectedCompany?.length}
              />
            )}
          </Element>
        </div>
      </div>
      <Element
        style={{ borderColor: '#D5D5D5' }}
        className={classes.groupSelect}
      >
        <GroupCriteria
          label="library.savePortfolio.PORTFOLIO"
          data={listSelected}
          isFlex={false}
          onClickDelete={handelDeletePort}
          isAll={isAll}
          renderWhenStatusAll={renderWhenStatusAll}
        />
        <GroupCriteria
          label="library.filterSetting.EXCLUDE"
          data={listIdsSelectedCompany}
          isFlex={false}
          onClickDelete={handelDeleteCompany}
        />
      </Element>
    </div>
  )
}
